(function() {
  if (window.lgCartItemCountSyncInitialized) {
    return;
  }
  window.lgCartItemCountSyncInitialized = true;

  var CART_MUTATION_PATH_REGEX = /\/cart\/(add|change|update|clear)(?:\.js)?$/;
  var refreshTimer = null;
  var isRefreshing = false;
  var pendingRefresh = false;

  function toUrl(input) {
    try {
      return new URL(input, window.location.origin);
    } catch (error) {
      return null;
    }
  }

  function extractRequestUrl(resource) {
    if (!resource) {
      return null;
    }

    if (typeof resource === 'string') {
      return resource;
    }

    if (typeof Request !== 'undefined' && resource instanceof Request) {
      return resource.url;
    }

    if (typeof resource.url === 'string') {
      return resource.url;
    }

    return null;
  }

  function isCartMutationUrl(url) {
    if (!url) {
      return false;
    }

    var parsedUrl = toUrl(url);
    if (!parsedUrl) {
      return false;
    }

    return CART_MUTATION_PATH_REGEX.test(parsedUrl.pathname);
  }

  function setItemCountOnCartIcon(icon, itemCount) {
    var countNode = icon.querySelector('.cart-item-count');

    if (itemCount > 0) {
      icon.classList.add('cart--not-empty');
      if (!countNode) {
        countNode = document.createElement('span');
        countNode.className = 'cart-item-count';
        icon.appendChild(countNode);
      }
      countNode.textContent = String(itemCount);
      return;
    }

    icon.classList.remove('cart--not-empty');
    if (countNode) {
      countNode.remove();
    }
  }

  function updateCartCountUI(itemCount) {
    var parsedCount = parseInt(itemCount, 10);
    if (isNaN(parsedCount) || parsedCount < 0) {
      parsedCount = 0;
    }

    var cartIcons = document.querySelectorAll('.header__nav-icon--cart');
    for (var i = 0; i < cartIcons.length; i += 1) {
      setItemCountOnCartIcon(cartIcons[i], parsedCount);
    }

    var legacyCartIcon = document.getElementById('orderNavIcon');
    if (legacyCartIcon) {
      if (parsedCount > 0) {
        legacyCartIcon.classList.add('item-in-cart');
      } else {
        legacyCartIcon.classList.remove('item-in-cart');
      }
    }
  }

  function refreshCartCount() {
    if (isRefreshing) {
      pendingRefresh = true;
      return;
    }

    isRefreshing = true;
    function onRefreshComplete() {
      isRefreshing = false;
      if (pendingRefresh) {
        pendingRefresh = false;
        scheduleRefresh();
      }
    }

    if (typeof window.fetch === 'function') {
      window.fetch(window.location.origin + '/cart.js', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      })
        .then(function(response) {
          if (!response || !response.ok) {
            return null;
          }
          return response.json();
        })
        .then(function(cart) {
          if (!cart || typeof cart.item_count === 'undefined') {
            return;
          }
          updateCartCountUI(cart.item_count);
        })
        .catch(function() {})
        .then(onRefreshComplete, onRefreshComplete);
      return;
    }

    var request = new XMLHttpRequest();
    request.open('GET', window.location.origin + '/cart.js', true);
    request.setRequestHeader('Accept', 'application/json');
    request.onreadystatechange = function() {
      if (request.readyState !== 4) {
        return;
      }

      if (request.status >= 200 && request.status < 300) {
        try {
          var cart = JSON.parse(request.responseText);
          if (cart && typeof cart.item_count !== 'undefined') {
            updateCartCountUI(cart.item_count);
          }
        } catch (error) {}
      }

      onRefreshComplete();
    };
    request.send();
  }

  function scheduleRefresh() {
    if (refreshTimer) {
      window.clearTimeout(refreshTimer);
    }

    refreshTimer = window.setTimeout(function() {
      refreshTimer = null;
      refreshCartCount();
    }, 80);
  }

  function patchFetch() {
    if (typeof window.fetch !== 'function') {
      return;
    }

    var originalFetch = window.fetch;
    window.fetch = function(resource, init) {
      var requestUrl = extractRequestUrl(resource);

      return originalFetch.apply(this, arguments).then(function(response) {
        var responseUrl = response && response.url ? response.url : requestUrl;
        if (response && response.ok && isCartMutationUrl(responseUrl)) {
          scheduleRefresh();
        }
        return response;
      });
    };
  }

  function patchXMLHttpRequest() {
    if (typeof window.XMLHttpRequest === 'undefined') {
      return;
    }

    var originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url) {
      this._lgCartMutationRequestUrl = url;
      return originalOpen.apply(this, arguments);
    };

    var originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function() {
      if (!this._lgCartMutationPatched) {
        this._lgCartMutationPatched = true;
        this.addEventListener('loadend', function() {
          if (this.status >= 200 && this.status < 300 && isCartMutationUrl(this.responseURL || this._lgCartMutationRequestUrl)) {
            scheduleRefresh();
          }
        });
      }

      return originalSend.apply(this, arguments);
    };
  }

  patchFetch();
  patchXMLHttpRequest();
})();
